import { Observable } from 'rxjs'
import { PoUpload } from '../../../models'

export abstract class PoUploadAdapter {

  abstract post(poUploadForm: PoUpload): Observable<PoUpload>
}
